<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>
                <v-toolbar card prominent dense>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                :disabled="!subscriptionId"
                                v-on="on"
                                @click="resetSubscription"
                            >
                                <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                :disabled="!subscriptionId"
                                v-on="on"
                                @click="saveSubscription"
                            >
                                <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("save") }}</span>
                    </v-tooltip>
                    <v-switch
                        class="mt-3"
                        v-model="showArchived"
                        :label="$t('showArchived')"
                    ></v-switch>
                </v-toolbar>

                <v-card-text class="v-scrollable">
                    <v-flex xs12 d-flex>
                        <v-select
                            v-model="subscriptionId"
                            :items="filteredSubscriptions"
                            item-text="title"
                            item-value="id"
                            :label="$t('subscription')"
                        ></v-select>
                    </v-flex>

                    <v-layout row wrap>
                        <v-flex xs9 pa-2>
                            <v-text-field
                                :label="$t('title')"
                                :hint="$t('title')"
                                v-model="title"
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs3 pa-2>
                            <v-checkbox :label="$t('archived')" v-model="isArchived" value="true"></v-checkbox>
                        </v-flex>
                    </v-layout>


                    <v-layout row wrap>
                        <v-flex xs12 sm4 pa-2>
                            <v-text-field
                                :label="$t('maxUsers')"
                                :hint="$t('maxUsers')"
                                v-model="maxUsers"
                                required
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm4 pa-2>
                            <v-text-field
                                :label="$t('maxPatterns')"
                                :hint="$t('maxPatterns')"
                                v-model="maxPatterns"
                                required
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm4 pa-2>
                            <v-text-field
                                :label="$t('maxModels')"
                                :hint="$t('maxModels')"
                                v-model="maxModels"
                                required
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm4 pa-2>
                            <v-text-field
                                :label="$t('maxLines')"
                                :hint="$t('maxLines')"
                                v-model="maxLines"
                                required
                            ></v-text-field>
                        </v-flex>
    <!--
                        <v-flex xs12 sm4 pa-2>
                            <v-text-field
                                :label="$t('maxOptimizationsPerDay')"
                                :hint="$t('maxOptimizationsPerDay')"
                                v-model="maxUsers"
                                required
                            ></v-text-field>
                        </v-flex>
    -->

                    </v-layout>

                    <v-divider class="my-2"></v-divider>
                    <v-layout column wrap>
                        <span>{{ $t("optimization") }}</span>
                        <v-checkbox hide-details :label="$t('denyExport')" v-model="settings.optimization.denyExport" :true-value="true" :false-value="false"></v-checkbox>
                        <v-checkbox hide-details :label="$t('lockCoreless')" v-model="settings.optimization.lockCoreless" :true-value="true" :false-value="false"></v-checkbox>
                        <v-checkbox hide-details :label="$t('lockCurvature')" v-model="settings.optimization.lockCurvature" :true-value="true" :false-value="false"></v-checkbox>
                        <v-checkbox hide-details :label="$t('lockWane')" v-model="settings.optimization.lockWane" :true-value="true" :false-value="false"></v-checkbox>
                    </v-layout>

                    <v-divider class="my-2"></v-divider>
                    <v-layout column wrap>
                        <span class="mb-0 pb-0">{{ $t("patterns") }}</span>
                        <v-checkbox hide-details :label="$t('denyEdit')" v-model="settings.patterns.denyEdit" :true-value="true" :false-value="false"></v-checkbox>
                        <v-checkbox hide-details :label="$t('denyImport')" v-model="settings.patterns.denyImport" :true-value="true" :false-value="false"></v-checkbox>
                        <v-checkbox hide-details :label="$t('denyExport')" v-model="settings.patterns.denyExport" :true-value="true" :false-value="false"></v-checkbox>
                    </v-layout>

                    <v-divider class="my-2"></v-divider>
                    <v-layout column wrap>
                        <span class="mb-0 pb-0">{{ $t("lengths") }}</span>
                        <v-checkbox hide-details :label="$t('lock')" v-model="settings.lengths.lock" :true-value="true" :false-value="false"></v-checkbox>
                    </v-layout>

                    <v-divider class="my-2"></v-divider>
                    <v-layout column wrap>
                        <span class="mb-0 pb-0">{{ $t("lumber") }}</span>
                        <v-checkbox hide-details :label="$t('lock')" v-model="settings.lumber.lock" :true-value="true" :false-value="false"></v-checkbox>
                    </v-layout>

                    <v-divider class="my-2"></v-divider>
                    <v-layout column wrap>
                        <span class="mb-0 pb-0">{{ $t("contracts") }}</span>
                        <v-checkbox hide-details :label="$t('lock')" v-model="settings.contracts.lock" :true-value="true" :false-value="false"></v-checkbox>
                    </v-layout>

                </v-card-text>
            </v-card>
            <message-box ref="MessageBox"/>
        </v-flex>

        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import MessageBox from "@/components/dialogs/MessageBox";

    export default {
        name: "LimitsManagement",

        components: {
            MessageBox
        },

        data () {
            return {
                alert: "",
                alertType: "success",

                breadCrumbs: [
                    { text: "Администрирование", disabled: false },
                    { text: "Ограничения",  disbaled: false }
                ],

                isArchived:     false,
                subscriptionId: null,
                subscriptions:  [],

                progressBarVisible: false,

                defaultSubscriptionSettings: {
                    optimization: {
                        denyExport:    true, // Запретить экспорт
                        lockCurvature: true, // Блокировать изменение параметров кривизны
                        lockWane:      true, // Блокировать изменение параметра расчёта с учётом обзола
                        lockCoreless:  true, // Блокировать изменение параметра использования бессердцевинной доски
                    },
                    contracts: {
                        lock: true, // Блокировать изменение справочника контрактов
                    },
                    lengths: {
                        lock: true, // Блокировать изменение справочника длин
                    },
                    lumber: {
                        lock: true, // Блокировать изменение справочника пиломатериалов
                    },
                    patterns: {
                        denyEdit:   true, // Запретить редактирование поставов
                        denyExport: true, // Запретить экспорт
                        denyImport: true, // Запретить импорт
                    },
                },

                title:        "",
                maxUsers:     1,
                maxPatterns:  1,
                maxModels:    1,
                maxLines:     1,
                settings: {
                    optimization: {
                        denyExport:    true, // Запретить экспорт
                        lockCoreless:  true, // Блокировать изменение параметра использования бессердцевинной доски
                        lockCurvature: true, // Блокировать изменение параметров кривизны
                        lockWane:      true, // Блокировать изменение параметра расчёта с учётом обзола
                    },
                    contracts: {
                        lock: true, // Блокировать изменение справочника заказов
                    },
                    lengths: {
                        lock: true, // Блокировать изменение справочника длин
                    },
                    lumber: {
                        lock: true, // Блокировать изменение справочника пиломатериалов
                    },
                    patterns: {
                        denyEdit:   true, // Запретить редактирование поставов
                        denyExport: true, // Запретить экспорт
                        denyImport: true, // Запретить импорт
                    },
                },

                //maxOptPerDay: 5,
                showArchived: false
            }
        },

        computed: {
            filteredSubscriptions () {
                return this.showArchived
                    ? this.subscriptions
                    : this.subscriptions.filter(subscription => subscription.isArchived == false);
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            }
        },

        watch: {
            alert (val) {
                let component = this;

                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            subscriptionId: function (val) {
                this.title        = "";
                this.maxUsers     = 0;
                this.maxPatterns  = 0;
                this.maxModels    = 0;
                this.maxLines     = 0;
                //this.maxOptPerDay = 0;

                this.subscriptions.forEach ((item) => {
                    if (item.id == val) {
                        this.title        = item.title;
                        this.maxUsers     = item.maxUsers;
                        this.maxPatterns  = item.maxPatterns;
                        this.maxModels    = item.maxModels;
                        this.maxLines     = item.maxLines;
                        //this.maxOptPerDay = item.maxOptPerDay;
                        this.isArchived   = item.isArchived;
                        this.settings     = item.settings;
                    }
                });
            }
        },

        mounted () {
            this.applyLocale();
            this.getSubscriptions();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("administration"), disabled: false },
                    { text: this.$t("limits"),         disabled: false }
                ];
            },

            /**
             * Получение списка подписок
             */
            getSubscriptions () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}subscriptions/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let subscrList = response.data.subscriptions

                            this.subscriptions = [];

                            subscrList.forEach((item) => {
                                this.subscriptions.push({
                                    id:          item.id,
                                    title:       item.Name,
                                    maxUsers:    item.MaxUsers,
                                    maxPatterns: item.MaxPatterns,
                                    maxModels:   item.MaxModels,
                                    maxLines:    item.MaxLines,
                                    settings:    JSON.parse(item.SettingsJSON) == null
                                        ? { ...this.defaultSubscriptionSettings }
                                        : JSON.parse(item.SettingsJSON),
                                    isArchived:  item.Visible == false
                                });
                            });
                        }

                        this.subscriptions.sort((a) => { //, b) => {
                            //return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
                            return !a.isArchived ? -1 : 1;
                        });

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData"));
                        }
                    });
            },

            /**
             * Сброс сделанных изменений до текущего сохранённого состояния
             */
            resetSubscription () {
                this.title        = "";
                this.maxUsers     = 0;
                this.maxPatterns  = 0;
                this.maxModels    = 0;
                this.maxLines     = 0;
                //this.maxOptPerDay = 0;
                this.settings     = { ...{}, ...this.defaultSubscriptionSettings };

                this.subscriptions.forEach ((item) => {
                    if (item.id == this.subscriptionId) {
                        this.title        = item.title;
                        this.maxUsers     = item.maxUsers;
                        this.maxPatterns  = item.maxPatterns;
                        this.maxModels    = item.maxModels;
                        this.maxLines     = item.maxLines;
                        //this.maxOptPerDay = item.maxOptPerDay;
                        this.isArchived   = false;
                    }
                });
            },

            /**
             * Сохранение параметров подписки
             */
            saveSubscription () {
                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}subscriptions/${this.subscriptionId}/`,
                    data: {
                        name:          this.title,
                        max_users:     this.maxUsers,
                        max_patterns:  this.maxPatterns,
                        max_models:    this.maxModels,
                        max_lines:     this.maxLines,
                        settings_json: JSON.stringify(this.settings),
                        visible:       !this.isArchived
                    },
                    withCredentials: true
                }).then(response => {
                    let r_data = response.data;

                    if (r_data.status == "success") {
                        this.alertType = "success";
                        this.alert     = this.$t("subscriptionUpdated");
                        //this.showMessageBox(this.$t("information"), this.$t("subscriptionUpdated"));

                        this.getSubscriptions();

                        this.dataUpdated = true;
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateSubscription"));
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) {
                            this.dialogWatcher();
                        }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {
                                window.location.reload();
                            }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateSubscription") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateSubscription"));
                    }
                });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .v-scrollable
        overflow-y: auto
        max-height: calc(100dvh - 144px)
</style>
